<template>
<div class="wireless-map-wrapper page-container-content tabgroup">
  <div class="full-wrapper">
    <div class="map-wrapper">
      <w-wireless-map-view :active="active" @node-click="onNodeClick"/>
    </div>
    <div class="detail-info-wrapper">
      <w-wireless-map-node-detail-info :data="selectedNode"/>
    </div>
  </div>
</div>
</template>

<script>
import WWirelessMapView from './components/WirelessMapView';
import WWirelessMapNodeDetailInfo from './components/WirelessMapNodeDetailInfo';

export default {
  name: 'WPerformanceNodeWirelessMap',
  components: {
    WWirelessMapView,
    WWirelessMapNodeDetailInfo,
  },
  props: {
    active: {
      type: Boolean,
      defulat: false,
    },
  },
  data() {
    return {
      selectedNode: null,
    };
  },
  methods: {
    onNodeClick(data) {
      this.selectedNode = data;
    },
  },
};
</script>
<style lang="scss" scoped>
.wireless-map-wrapper .full-wrapper {
  padding: 20px;
  $detail-info-width: 450px;
  .map-wrapper {
    float:left;
    display: inline-block;
    width: calc(100% - #{$detail-info-width});
    height: 100%;
  }
  .detail-info-wrapper {
    float: right;
    display: inline-block;
    width: $detail-info-width;
    padding-left: 15px;
    height: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/performance/node/wireless-map/index.vue